import { gql } from "@apollo/client";

export enum BookingReportType {
  SERVICE_BOOKINGS = "SERVICE_BOOKINGS",
  MONTHLY_TOTALS = "MONTHLY_TOTALS",
  PRACTITIONER_SERVICES = "PRACTITIONER_SERVICES",
}

export const get_booking_reports = gql`
  query GetBookingReports(
    $queryType: BookingReportType!
    $clinicCode: String!
    $fromDate: String
    $toDate: String
    $take: Int!
    $skip: Int!
  ) {
    getBookingReports(
      queryType: $queryType
      clinicCode: $clinicCode
      fromDate: $fromDate
      toDate: $toDate
      take: $take
      skip: $skip
    ) {
      serviceBookings {
        serviceName
        month
        bookingCount
      }
      monthlyTotals {
        month
        totalBookings
      }
      practitionerServices {
        practitionerName
        serviceName
        bookingCount
      }
    }
  }
`;

export interface ServiceBookingRow {
  serviceName: string;
  month: string;
  bookingCount: number;
}

export interface MonthlyTotalRow {
  month: string;
  totalBookings: number;
}

export interface PractitionerServiceRow {
  practitionerName: string;
  serviceName: string;
  bookingCount: number;
}

export interface BookingReportsResponse {
  serviceBookings?: ServiceBookingRow[] | null;
  monthlyTotals?: MonthlyTotalRow[] | null;
  practitionerServices?: PractitionerServiceRow[] | null;
}

export interface GetBookingReportsData {
  getBookingReports: BookingReportsResponse | null;
}

export function getBookingReportsVar(args: {
  queryType: BookingReportType;
  clinicCode: string;
  fromDate?: string | null;
  toDate?: string | null;
  take?: number;
  skip?: number;
}) {
  const {
    queryType,
    clinicCode,
    fromDate,
    toDate,
    take = 20,
    skip = 0,
  } = args;
  return {
    queryType,
    clinicCode,
    take,
    skip,
    ...(fromDate != null && fromDate !== "" ? { fromDate } : {}),
    ...(toDate != null && toDate !== "" ? { toDate } : {}),
  };
}
